import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { labels, profile } from '../data/content';
import Rich from './Rich';
import { FOCUS_RING } from './styles';

const BUTTON = `inline-flex h-11 items-center rounded-sm px-5 text-sm font-medium transition-colors ${FOCUS_RING}`;

export default function Hero() {
  const { lang, t } = useLanguage();

  // 현재 언어의 이력서를 먼저 보여준다
  const resumes = [
    { href: profile.resume.ko, label: labels.resumeKo, lang: 'ko' },
    { href: profile.resume.en, label: labels.resumeEn, lang: 'en' },
  ].sort((a, b) => (a.lang === lang ? -1 : b.lang === lang ? 1 : 0));

  return (
    <section id="top" className="border-b border-stone-200 pb-20 pt-36 md:pt-32">
      <div className="mx-auto max-w-5xl px-5">
        <p className="mb-4 text-sm uppercase tracking-[0.2em] text-stone-500">{profile.title}</p>
        {/* 좁은 화면에서는 한글·영문 이름을 두 줄로, sm 이상에서 한 줄로 */}
        <h1 className="text-4xl font-extrabold leading-tight tracking-tight md:text-6xl">
          {profile.nameKo}
          <span className="sr-only"> </span>
          <span className="mx-3 hidden font-light text-stone-400 sm:inline" aria-hidden="true">
            |
          </span>
          <span className="block whitespace-nowrap font-light sm:inline">{profile.nameEn}</span>
        </h1>
        <p className="mt-8 whitespace-pre-line text-balance text-lg font-medium leading-relaxed md:text-xl">
          <Rich text={t(profile.tagline)} />
        </p>
        <p className="mt-4 max-w-2xl text-pretty leading-relaxed text-stone-600">
          <Rich text={t(profile.intro)} />
        </p>

        <div className="mt-8 flex flex-wrap gap-x-8 gap-y-2 text-sm text-stone-600">
          <a
            href={`mailto:${profile.email}`}
            className={`rounded-sm underline underline-offset-4 hover:text-stone-900 ${FOCUS_RING}`}
          >
            {profile.email}
          </a>
          <a href={`tel:${profile.phone.replace(/[^+\d]/g, '')}`} className={`rounded-sm hover:text-stone-900 ${FOCUS_RING}`}>
            {profile.phone}
          </a>
          <a
            href={profile.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className={`rounded-sm hover:text-stone-900 ${FOCUS_RING}`}
          >
            LinkedIn
          </a>
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          {resumes.map((r, i) => (
            <a
              key={r.lang}
              href={r.href}
              download
              className={
                i === 0
                  ? `${BUTTON} bg-stone-900 text-stone-50 hover:bg-stone-700`
                  : `${BUTTON} border border-stone-300 text-stone-700 hover:border-stone-900 hover:text-stone-900`
              }
            >
              {t(r.label)} PDF
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
